import { createFileRoute } from '@tanstack/react-router'
import { CommissionRunPage } from '../../../../features/commissions/run-page'
import { runPageSearchSchema } from '../../../../features/commissions/search'

export const Route = createFileRoute('/_app/commissions/runs/$runId')({
  staticData: { crumb: 'commissionRun' },
  validateSearch: runPageSearchSchema,
  component: CommissionRunPage,
})
